import { render, staticRenderFns } from "./ContentForeignismSection.vue?vue&type=template&id=5069d72f"
import script from "./ContentForeignismSection.vue?vue&type=script&lang=ts"
export * from "./ContentForeignismSection.vue?vue&type=script&lang=ts"
import style0 from "./ContentForeignismSection.vue?vue&type=style&index=0&id=5069d72f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports